export const GENERIC_ERROR_MESSAGE = "We were unable to complete your request due to an error on our end"

const CONTAINER_QUERY = ".js-notices-container"
const createInfoNotice = (message: string) => {
  const holder = document.querySelector(CONTAINER_QUERY)

  let notice = document.createElement("gc-notice")
  notice.setAttribute("type", "info")
  notice.setAttribute("body", message)

  holder.innerHTML = ""
  holder.appendChild(notice)
}

const createErrorNotice = (message: string) => {
  const holder = document.querySelector(CONTAINER_QUERY)

  let notice = document.createElement("gc-notice")
  notice.setAttribute("type", "error")
  notice.setAttribute("body", message)

  holder.innerHTML = ""
  holder.appendChild(notice)
  // This is a workaround for notice.scrollIntoView() not working properly on chrome.
  window.scroll({ top: 0, behavior: "smooth" })
}

export { createInfoNotice, createErrorNotice }
